<script setup lang="ts">
const { sortedContents, onGalleryViewMounted, onGalleryViewUnmounted, onUpdatedViewModeSettings, state } = useGalleryView()
const { state: viewModeState } = useViewMode()

const file = computed(() => {
  const fileId = state.value.currentFileId
  if (!fileId)
    return sortedContents.value[0]
  return sortedContents.value.find(file => file.fileId === fileId)
})

onMounted(onGalleryViewMounted)
onUnmounted(onGalleryViewUnmounted)
watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <div class="gallery-view">
    <div class="nav-spacer" />
    <collection-gallery-preview
      v-if="file"
      :file
      class="gallery-preview"
    />
    <collection-scroll-container
      horizontal
      virtual-horizontal
      class="gallery-list"
    >
      <div class="gallery-scroll">
        <collection-gallery-file
          v-for="thumbnailFile in sortedContents"
          :key="thumbnailFile.fileId"
          :file="thumbnailFile"
        />
      </div>
    </collection-scroll-container>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.gallery-view
  @apply flex flex-col h-full

.nav-spacer
  @apply pointer-events-none w-full flex-none h-[#{$nav-h-default}]

.gallery-preview
  @apply flex-grow-1 min-h-0

.gallery-list
  @apply flex-none h-[100px] w-full

.gallery-scroll
  @apply h-full w-full py-[#{$page-gallery-py-preview}] px-[#{$page-gallery-px-preview}]
  @apply flex gap-[#{$page-icon-p-main}]
</style>
